export enum ThemeType {
  DARK = 'dark',
  LIGHT = 'light',
}
